import { useQuery } from "@tanstack/react-query";

import { getActorsActorID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { ACTORS_QUERY_KEYS } from "./queryKeys";

export function useActorDetailQuery(actorID?: string) {
  return useQuery({
    queryKey: ACTORS_QUERY_KEYS.detail(actorID!),
    queryFn: processResponse(() => getActorsActorID(actorID!)),
    enabled: !!actorID,
  });
}
